import PropTypes from "prop-types";
import { Navigate, NavLink as RouterLink, useNavigate } from "react-router-dom";
// @mui
import { Box, List, ListItemText } from "@mui/material";
//
import { StyledNavItem, StyledNavItemIcon } from "./styles";

import SvgColor from "../../components/svg-color";
import { useContext } from "react";
import { AuthContext } from "../../context/auth-context";

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

const icon = (name) => (
  <SvgColor
    src={`/tams/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

export default function NavSection({ data = [], ...other }) {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutHandler = () => {
    auth.logout();
    auth.accessRemove();
    navigate("/login", { replace: true });
  };
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
        <NavItem
          item={{
            title: "logout",
            path: "/login",
            icon: icon("ic_lock"),
          }}
          onClick={logoutHandler}
        />
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        "&.active": {
          color: "text.primary",
          bgcolor: "action.selected",
          fontWeight: "fontWeightBold",
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
